export enum ErrorCode {
  EntityNotFound = 'EntityNotFound',
  NameNotUnique = 'NameNotUnique',
  ShortNameNotUnique = 'ShortNameNotUnique',
  EntityListNotFound = 'EntityListNotFound',
  InvalidDateRange = 'InvalidDateRange',
  FieldRequired = 'FieldRequired',
  FieldMustBeUnique = 'FieldMustBeUnique',
  EquipmentAssignmentEquipmentTypeNotAvailableForCarriers = 'EquipmentAssignmentEquipmentTypeNotAvailableForCarriersm',
  EquipmentAssignmentEquipmentTypeNotAvailableForYard = 'EquipmentAssignmentEquipmentTypeNotAvailableForYard',
  EquipmentCannotBeSetToInactiveBecauseAssignedToVisit = 'EquipmentCannotBeSetToInactiveBecauseAssignedToVisit',
  ShiftTimeConflict = 'ShiftTimeConflict',
}
